import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

/**
 * Generic breadcrumb component for subpages. Pass `items` as
 * [{ label: "Über uns", to: "/ueber-uns" }, ...] — the last item is rendered
 * as the current page (non-link) automatically.
 */
export default function Breadcrumbs({ items = [] }) {
  if (!items.length) return null;

  // JSON-LD BreadcrumbList for SEO
  const ldJson = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Start",
        item: "https://wagenhofer.capital/",
      },
      ...items.map((it, idx) => ({
        "@type": "ListItem",
        position: idx + 2,
        name: it.label,
        item: `https://wagenhofer.capital${it.to}`,
      })),
    ],
  };

  return (
    <nav
      aria-label="Breadcrumb"
      data-testid="breadcrumbs"
      className="container-x pt-28 pb-2"
    >
      <ol className="flex flex-wrap items-center gap-2 text-xs text-zinc-500 tracking-[0.18em] uppercase">
        <li className="flex items-center gap-2">
          <Link
            to="/"
            className="flex items-center gap-1.5 hover:text-[#D4AF37] transition-colors"
            aria-label="Startseite"
          >
            <Home className="w-3.5 h-3.5" strokeWidth={1.5} />
            Start
          </Link>
        </li>
        {items.map((item, idx) => {
          const isLast = idx === items.length - 1;
          return (
            <li key={item.to} className="flex items-center gap-2">
              <ChevronRight className="w-3 h-3 text-zinc-700" strokeWidth={1.5} />
              {isLast ? (
                <span className="text-zinc-300" aria-current="page">
                  {item.label}
                </span>
              ) : (
                <Link
                  to={item.to}
                  className="hover:text-[#D4AF37] transition-colors"
                >
                  {item.label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(ldJson) }}
      />
    </nav>
  );
}
